export default "__VITE_ASSET__D7hR_AzS__"